import React, { useState } from 'react'
import CustomerTable from '../components/(admin)/CustomerTable'
import './CustomerManagement.css'

const CustomerManagement = () => {
  // Static data for customers
  const [customers, setCustomers] = useState([
    { id: 1, name: 'Usman', role: 'Owner', status: 'Joined' },
    { id: 2, name: 'Aashar', role: 'Trainer', status: 'Pending' },
    { id: 3, name: 'Ahmad', role: 'Editor', status: 'Pending' },
    { id: 4, name: 'Usman', role: 'Viewer', status: 'Pending' },
    { id: 5, name: 'Usman', role: 'Editor', status: 'Pending' },
    { id: 6, name: 'Usman', role: 'Viewer', status: 'Pending' },
    { id: 7, name: 'Usman', role: 'Editor', status: 'Failed' },
    { id: 8, name: 'Usman', role: 'Viewer', status: 'Failed' }
  ])

  const handleInviteCustomer = () => {
    console.log('Invite Customer clicked')
    // Add your invite customer logic here
    // This could open a modal, navigate to a form, etc.
  }

  const handleEdit = (customer) => {
    console.log('Edit customer:', customer)
    // Add your edit logic here
    // This could open a modal with edit form
  }

  const handleDelete = (customer) => {
    console.log('Delete customer:', customer)
    // Confirm deletion
    if (window.confirm(`Are you sure you want to delete ${customer.name}?`)) {
      setCustomers(customers.filter(c => c.id !== customer.id))
    }
  }

  return (
    <div className="customer-management-container">
      <div className="customer-management-header">
        <h1 className="page-title">Customer Management</h1>
        <button className="invite-customer-btn" onClick={handleInviteCustomer}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Invite Customer
        </button>
      </div>

      <CustomerTable
        data={customers}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
    </div>
  )
}

export default CustomerManagement
